import GenericModel from '../generic-model';
import Address from './address';

export default class AddressWithType extends GenericModel {
  type?: AddressType;
  address?: Address;

  constructor(type?: AddressType) {
    super();
    this.type = type;
    this.address = new Address();
  }
}

export type AddressType = 'primary' | 'invoicing' | 'delivery' | 'visiting';
